export const isBundleSet = (product) =>
    Boolean(
        (product?.type?.set || product?.productType?.set || product?.hitType === 'set') &&
            ['Fixed', 'Flexible'].includes(product?.c_bundleType),
    )

export const getBundleSetInfo = (product) =>
    product?.c_bundleType === 'Fixed'
        ? product?.c_bundleProductsInfo?.fixedBundle
        : product?.c_bundleProductsInfo?.flexibleBundles

// Match the initial PDP total: flexible bundles start with their primary products only.
export const getBundlePrice = (product) => {
    if (!isBundleSet(product)) {
        return undefined
    }

    const primaryProducts = getBundleSetInfo(product)?.primaryProducts
    if (!primaryProducts?.length) {
        return undefined
    }

    const totalCents = primaryProducts.reduce(
        (sum, primary) => sum + Math.round(Number(primary.price || 0) * 100),
        0,
    )
    return totalCents / 100
}
